module.exports = __webpack_public_path__ + "static/fieldwork-1871a1e765166c8b9983c7c9c1c110b9.jpg";